// Car-only lighting is intentionally quieter than the studio/showroom treatment.
// These gains apply to radiance once, rather than changing material colors.
export const CAR_ONLY_LIGHTING = Object.freeze({
  fallbackEnvironmentGain: 0.4,
  roomEnvironmentGain: 0.55,
  directGain: 0.5,
  diffuseGain: 0.5,
  maxDirectIntensity: 1.5,
  maxDiffuseCoefficient: 1.5,
  stabilizationSeconds: 0.25,
  stabilizationSamples: 8,
});
